import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';
import { useIntl } from 'react-intl';

import { getFormattedDateTime } from '../../helpers/DateTime';
import { formatBytes } from '../../helpers/Files';

const ImporterModalListItem = ({
  item,
  selectedItems,
  addSelectedItem,
  removeSelectedItem,
  setPath,
  addPathElement,
  topPage,
}) => {
  const intl = useIntl();

  const isSelected = !!selectedItems.find(si => (si.id === item.id));
  const icon = item.type === 'folder' ? 'fa-folder-closed' : 'fa-file';

  const handleOpenFolder = (e) => {
    e.preventDefault();
    setPath(item.path || item.id);
    addPathElement({
      path: item.id,
      label: item.name,
    });
  };

  return (
    <tr>
      {!topPage && (
        <td className="selector">
          <Input
            type="checkbox"
            className="input-check check-s form-check-input"
            id={`file-${item.id}`}
            checked={isSelected}
            onChange={() => {
              if (isSelected) {
                removeSelectedItem(item);
              } else {
                addSelectedItem(item);
              }
            }}
          />
        </td>
      )}
      <td className="icon">
        {item.thumbnail ? (
          <div className="thumbnail">
            <img src={item.thumbnail} alt="" />
          </div>
        ) : (
          <div className="icon-gray">
            {item.icon ? (
              <img src={`/images/integrations/${item.icon}`} alt={item.name} />
            ) : (
              <i className={`fa-regular ${icon}`} />
            )}
          </div>
        )}
      </td>
      <td>
        {item.type === 'folder' ? (
          <a href="#go" onClick={handleOpenFolder}>
            {item.name}
          </a>
        ) : (
          item.name
        )}
      </td>
      {!topPage && (
        <>
          <td>
            {item.type === 'folder' ? intl.formatMessage({ defaultMessage: 'Folder' }) :
              item.extension}
          </td>
          <td>
            {item.size ? formatBytes(item.size) : '-'}
          </td>
          <td>
            {item.type === 'folder' ? '-' : getFormattedDateTime(item.updated_at)}
          </td>
        </>
      )}
    </tr>
  );
};

ImporterModalListItem.propTypes = {
  item: PropTypes.object.isRequired,
  selectedItems: PropTypes.array.isRequired,
  addSelectedItem: PropTypes.func.isRequired,
  removeSelectedItem: PropTypes.func.isRequired,
  setPath: PropTypes.func.isRequired,
  addPathElement: PropTypes.func.isRequired,
  topPage: PropTypes.bool.isRequired,
};

export default ImporterModalListItem;
